const getMuralArtistsNames = (mural) => {
  const artistNames = mural.override_artist_name ? mural.override_artist_name : mural.artists.map((artist) => artist.mural_artists_id.name).join(' & ');
  return artistNames;
};

module.exports.getMuralArtistsNames = getMuralArtistsNames;